import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Paper,
  Button,
  Typography,
  Modal,
  Input,
  Select,
  Icon,
} from '@safedns/skydns-ui-react-lib';

import {
  useGetUserQuery,
  useGetProfilesQuery,
  useGetCollectionsQuery,
  useUpdateCollectionMutation,
} from '../../services/ADapi';

import ArrowButton from '../UI/go-back/GoBack';
import CollectionsConfigurate from './CollectionsConfigurate';
import SubmitBar from './SubmitBar';

import sprite from '../../icons/sprite.svg';

import './Collections.scss';
import appStyles from '../app/App.module.scss';

const CollectionsEditForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const selectedUserIds = useSelector(
    (state) => state.tree.selectedUsersIdsForBackend
  );

  const {
    data: { user_id },
  } = useGetUserQuery();

  const { data: profilesList = [] } = useGetProfilesQuery(user_id);

  const { data: collectionById = {} } = useGetCollectionsQuery(user_id, {
    selectFromResult: ({ data, isLoading }) => {
      const collectionId = +id;

      return {
        isLoading,
        data: data?.find((collection) => collection.id === collectionId),
      };
    },
  });

  const [updateCollection] = useUpdateCollectionMutation();

  const [isShowCollectionModal, setIsShowCollectionModal] = useState(false);

  const [name, setName] = useState(collectionById.name);
  const [nameIsBlur, setNameIsBlur] = useState(false);
  const [nameError, setNameError] = useState(
    'Collection name field is required'
  );
  const [policy, setPolicy] = useState(collectionById.profile);
  const [checkedUsers, setCheckedUsers] = useState([]);
  const [isFormValid, setFormState] = useState(false);
  const [formIsSuccess, setFormIsSuccess] = useState(false);
  const [updateCollectionData, setCreateCollectionData] = useState({
    plan_code: 'RESELLER',
    priority: collectionById.priority,
    profile: collectionById.profile,
    domains: [],
    groups: [],
    ad_users: collectionById.ad_users,
  });
  const [submitBarDialogState, setSubmitBarDialogState] = useState(false);

  useEffect(() => {
    setCheckedUsers(collectionById.ad_users);
  }, [collectionById]);

  useEffect(() => {
    nameError ? setFormState(false) : setFormState(true);
  }, [nameError]);

  useEffect(() => {
    setCreateCollectionData({
      ...updateCollectionData,
      ad_users: selectedUserIds,
    });
    setFormState(true);

    // eslint-disable-next-line
  }, [selectedUserIds]);

  const nameHandler = (e) => {
    setName(e.target.value);

    if (!e.target.value) {
      setNameError('Name field is required');
    } else {
      setNameError('');
      setCreateCollectionData({
        ...updateCollectionData,
        name: e.target.value,
      });
    }
  };

  const policyHandler = (e) => {
    setPolicy(e.target.value);

    setCreateCollectionData({
      ...updateCollectionData,
      profile: e.target.value,
    });
  };

  const blurHandler = (e) => {
    switch (e.target.name) {
      case 'name':
        setNameIsBlur(true);
        break;
      default:
        break;
    }
  };

  const sumbitForm = async (e) => {
    e.preventDefault();

    try {
      await updateCollection({
        user_id,
        id,
        collectionData: updateCollectionData,
      }).unwrap();
    } catch (error) {
      console.error(error);
    }

    setFormIsSuccess(!formIsSuccess);
    setFormState(false);
    setIsShowCollectionModal(true);

    setNameError('');
  };

  const onToggleCollectionModal = () => {
    navigate('/collections');
    return setIsShowCollectionModal(false);
  };

  const successCircleCls = appStyles['circle'] + ' ' + appStyles['success'];

  return (
    <div className="collections-form-wrapper">
      <ArrowButton
        url="/collections"
        direction="left"
        title="Редактирование коллекции"
      />
      <Paper sx={{ position: 'relative' }}>
        <form className="collections-form-header">
          <div className="form-item">
            <Input
              value={name}
              size="medium"
              placeholder="Название коллекции"
              onChange={nameHandler}
              onBlur={blurHandler}
            />
            {nameIsBlur && nameError && (
              <span className="validate-error">{nameError}</span>
            )}
          </div>
          <div className="form-item">
            <Select value={policy} onChange={policyHandler}>
              {profilesList.map((option) => (
                <option key={Math.random()} value={option.id}>
                  {option.name}
                </option>
              ))}
            </Select>
          </div>
        </form>

        <CollectionsConfigurate
          collectionName={name}
          checkedUsers={checkedUsers}
        />

        <SubmitBar
          isFormValid={isFormValid}
          onSubmit={sumbitForm}
          buttonText="Сохранить коллекцию"
          dialogState={submitBarDialogState}
          dialogAction={setSubmitBarDialogState}
        />
      </Paper>

      <Modal
        title="Коллекция изменена"
        isOpen={isShowCollectionModal}
        onClose={onToggleCollectionModal}
        sx={{ maxWidth: 384, textAlign: 'center' }}
      >
        <div className="collections-success-modal">
          <div className={successCircleCls}>
            <Icon
              id="collection-created"
              sprite={sprite}
              width={28}
              height={28}
              color="white"
            />
          </div>
          <ul className="success-modal-list">
            <li>
              <Typography variant="body2">Название коллекции:</Typography>
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                {name}
              </Typography>
            </li>
            <li>
              <Typography variant="body2">ID профиля:</Typography>
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                {policy}
              </Typography>
            </li>
            <li>
              <Typography variant="body2">Количество пользователей:</Typography>{' '}
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                {selectedUserIds.length}
              </Typography>
            </li>
          </ul>
          <Button
            variant="primary"
            size="small"
            onClick={onToggleCollectionModal}
            sx={{ width: '100%' }}
          >
            Закрыть
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default CollectionsEditForm;
